angular.module("ainapp")
    .controller("hrDashController", ["app.config", "$scope", "LoginService", "AuthenticationService", "$state", "$stateParams", "MainService", "localStorageService",
                function (config, $scope, LoginService, AuthenticationService, $state, $stateParams, MainService, localStorageService) {


            $scope.PageName = "HR Dashboard";
            $scope.TokenInfo = AuthenticationService.getTokenInfo();
            if ($scope.TokenInfo == null) {
                $state.go("login");
            } else {
                $scope.checkUserPageAccess($scope.PageName);
            }


            $scope.Init = function () {

                $scope.Docs = [];
                MainService.EmployeeDocsInHome().then(function (response) {
                    $scope.Docs = response.data;
                })

                $scope.AttendanceList = [];
                MainService.GetCurrentDayAttendance().then(function (response) {
                    $scope.AttendanceList = response.data;
                })

                $scope.Birthdays = [];
                MainService.GetRecentBirthdays().then(function (response) {
                    $scope.Birthdays = response.data;
                })


            }
            $scope.Init();

                        }])
